<template>
	<el-dialog
		:show-close="true"
		title="修改登录邮箱"
		class="update-email-dialog"
		top="0"
		:visible.sync="show"
		:close-on-click-modal="false"
		:close-on-press-escape="false"
		@close="$parent.getDoctorDetail()"
		width="380px">
		<el-form ref="form" class="info" :model="form" label-width="100px" label-suffix="："
			:hide-required-asterisk="true">
			<el-form-item label="新邮箱" prop="email"
				:rules="[
            { required: true, message: '请输入新邮箱', trigger: 'blur'},
            { pattern: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/, message: '请输入正确的邮箱地址', trigger: 'blur'},
					]">
				<el-input v-model="form.email" clearable style="width: 220px;"
					placeholder="新邮箱"></el-input>
			</el-form-item>
			<el-form-item label="短信验证码" prop="code"
				:rules="[
            { required: true, message: '请输入短信验证码', trigger: 'blur'},
					]">
				<el-input v-model="form.code" clearable style="width: 100px;"
					placeholder="验证码"></el-input>
				<el-button style="width: 120px;" :disabled="sendBtnDisable" @click="sendEmailCode()">{{sendBtnText}}</el-button>
			</el-form-item>
			<el-form-item>
				<el-button style="background: #567BFF;border-color: #567BFF;float: right;width: 80px;margin-right: 20px;"
					type="primary" size="mini" @click="save()">保存</el-button>
			</el-form-item>
		</el-form>

	</el-dialog>
</template>

<script>
  import base from "@/api/common";
  import $ from 'jquery';

  export default {
    name: "UpdateMobile",
    props: {
      curEmail: {
        type: String,
        default: null
      }
    },
    data() {
      return {
        show: false,
        form: {
          email: '', //手机号码
          code: '', //短信验证码
        },
        sendBtnText: '发送验证码',
        sendBtnDisable: false,
      }
    },
    methods: {
      showDialog() {
        this.form = {
          email: '',
          code: ''
        };
        this.show = true;
      },
      save() {
        let vm = this;
        let postData = {
          email: vm.form.email,
          emailCode: vm.form.code,
        }
        vm.$ajax.post(base.api.updateEmail_email + "?" + $.param(postData))
          .then((res) => {
            if (res.data.status == 'success') {
              vm.$message.success('修改成功');
              vm.show = false;
            } else {
              vm.$message.error('修改失败');
            }
          }).catch((err) => {
          console.error(err);
          vm.$message.error('操作失败');
        })
      },
      sendEmailCode() {
        let vm = this;
        if (!base.reg.email.test(vm.form.email)) {
          vm.$message.warning('请输入正确手机号')
          return;
        }
        if (vm.form.email == vm.curEmail) {
          vm.$message.warning('系统检测到手机号码没有改变')
          return;
        }

        vm.$ajax.post(base.api.email.udpateEmail + '?email=' + vm.form.email)
          .then((res) => {
            if (res.data.status == 'success') {
              vm.btnReset();
              vm.$message.success('验证码发送成功');
            } else {
              vm.$message.error(res.data.message);
						}
          }).catch((err) => {
          console.error(err);
          vm.$message.error('操作失败');
        })
      },
      btnReset() {
        let vm = this;
        vm.sendBtnDisable = true;
        let count = 60;
        vm.sendBtnText = '重新发送(' + count + ')';
        const countDown = () => {
          if (count > 0) {
            count--;
            vm.sendBtnText = '重新发送(' + count + ')';
            setTimeout(countDown, 1000);
          } else {
            vm.sendBtnText = '发送验证码';
            vm.sendBtnDisable = false;
          }
        }
        countDown();
      }
    }
  }
</script>

<style scoped lang="scss">
</style>
